import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "The Guide", id: "product" },
  { label: "Free Prompt", id: "email-capture" },
  { label: "Founder", id: "founder" },
  { label: "Affiliate", id: "affiliate" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 transition-colors duration-500"
      style={{
        background: scrolled ? "rgba(250,249,246,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(18px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(26,26,26,0.06)" : "1px solid transparent",
      }}
      data-testid="nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-4 md:py-5 flex items-center justify-between">
        <button onClick={() => go("hero-section")} className="text-left" data-testid="nav-brand">
          <span className="font-serif italic text-2xl md:text-3xl">Findaura</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-[11px] tracking-[0.2em] uppercase text-[#1A1A1A] hover:text-[#C28C55] transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden px-6 pb-8 pt-2"
            style={{ background: "rgba(250,249,246,0.98)", backdropFilter: "blur(18px)" }}
          >
            <div className="flex flex-col gap-6 pt-4 border-t border-[#1A1A1A]/10">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  className="text-left font-serif italic text-2xl"
                  data-testid={`nav-mobile-link-${l.id}`}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
